module.exports = __webpack_public_path__ + "static/media/fa-brands-400.9ec698d1.ttf";